import { invitationTokenSchema } from '@/features/invitations/types/organizationInvitation';
import { z } from 'zod';

export interface LoginFinalizeResponse {
  status: 'COMPLETED' | 'NO_CHANGE';
  provider: 'PASSWORD' | 'GOOGLE' | 'MICROSOFT';
  tokenRefreshRequired: boolean;
  passwordSetup: 'COMPLETED' | 'NONE';
  invitation: { id: string; status: 'ACCEPTED' } | null;
}

/** Ephemeral client state for one login-finalization command. */
export interface LoginAttempt {
  uid: string;
  email: string | null;
  authTime: string;
  provider: string | null;
  invitationToken: string | null;
  key: string;
}

export const loginCompletionSearchSchema = z.object({
  invitationToken: invitationTokenSchema.optional().catch(undefined),
});
